// // import { Html5QrcodeScanner } from "html5-qrcode";
// import { Html5Qrcode } from "html5-qrcode";

// import { useState, useEffect } from "react"; // import useRef
// import PropTypes from "prop-types";
// import { Grid, Icon, Snackbar, Alert, Box, Typography, IconButton } from "@mui/material";
// import MDButton from "theme/components/MDButton";
// import MDBox from "theme/components/MDBox";
// import MDTypography from "theme/components/MDTypography";

// function QRScannerField({ displayName, fieldRef, options }) {
//   const [fieldError, showFieldError] = useState(false);
//   const [errorMsg, setErrorMsg] = useState(null);

//   const [isScanning, setIsScanning] = useState(false);
//   const [scannedText, setScannedText] = useState(null);
//   const [scannerObj, setsCannerObj] = useState(null);

//   const config = { fps: 10, qrbox: { width: 250, height: 250 } };

//   function onScanSuccess(decodedText, decodedResult) {
//     // handle the scanned code as you like, for example:
//     // console.log(`Code matched = ${decodedText}`, decodedResult);
//     setScannedText(decodedText);
//     closeScanning();
//   }

//   function openScanner(camera) {
//     scannerObj.start(camera, config, onScanSuccess);
//     setIsScanning(true);
//   }

//   function closeScanning() {
//     if (scannerObj === null) {
//       console.log("Scanner object null");
//       return;
//     }

//     try {
//       scannerObj.stop();
//       setIsScanning(false);
//     } catch {}

//     // scannerObj
//     //   .stop()
//     //   .then((ignore) => {
//     //     setIsScanning(false);
//     //   })
//     //   .catch((err) => {
//     //     // Stop failed, handle it.
//     //     console.warn(`Code scan error = ${err}`);
//     //     setErrorMsg(err);
//     //     showFieldError(true);
//     //   });
//   }

//   function initScanning() {
//     Html5Qrcode.getCameras()
//       .then((devices) => {
//         if (devices && devices.length) {
//           var cameraId = devices[0].id;
//           let camera = { deviceId: { exact: cameraId } };
//           if (devices.length > 1) {
//             camera = { facingMode: { exact: "environment" } };
//           }
//           openScanner(camera);
//         }
//       })
//       .catch((err) => {
//         // handle err
//         console.warn(`Code scan error = ${err}`);
//         setErrorMsg(`Code scan error = ${err}`);
//         showFieldError(true);
//       });
//   }

//   useEffect(() => {
//     setsCannerObj(new Html5Qrcode(`${fieldRef}_scanner`));
//   }, []);

//   return (
//     <Box>
//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         autoHideDuration={5000}
//         onClose={() => showFieldError(false)}
//         open={fieldError}
//       >
//         <Alert severity="error" sx={{ width: "100%" }}>
//           {errorMsg}
//         </Alert>
//       </Snackbar>
//       <Box sx={{ minWidth: 120, width: "100%" }}>
//         <Grid container spacing={3}>
//           <Grid item xs={6} md={6} lg={6}>
//             <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
//               {displayName}
//             </Typography>
//           </Grid>
//           <Grid mt={-1} item xs={6} md={6} lg={6}>
//             <Box align="right">
//               {!isScanning ? (
//                 <IconButton
//                   color="primary"
//                   variant="contained"
//                   iconOnly
//                   size="small"
//                   onClick={() => {
//                     initScanning();
//                   }}
//                   options={options}
//                 >
//                   <Icon>qr_code_scanner</Icon>
//                 </IconButton>
//               ) : (
//                 <IconButton
//                   color="error"
//                   variant="contained"
//                   iconOnly
//                   size="small"
//                   onClick={() => {
//                     closeScanning();
//                   }}
//                   options={options}
//                 >
//                   <Icon>close</Icon>
//                 </IconButton>
//               )}
//             </Box>
//           </Grid>
//         </Grid>
//         <Box>
//           <div id={`${fieldRef}_scanner`}></div>
//         </Box>
//         <Box mt={isScanning ? 3 : 0}>
//           {scannedText ? (
//             <MDBox>
//               <MDTypography variant="h6" fontSize={14} fontWeight="regular">
//                 <b>Scan Result:</b>
//                 <br />
//                 {scannedText}
//               </MDTypography>
//               <MDBox>
//                 <MDButton
//                   size="small"
//                   onClick={() => {
//                     setScannedText(null);
//                   }}
//                 >
//                   [clear]
//                 </MDButton>
//               </MDBox>
//             </MDBox>
//           ) : (
//             <Typography variant="h6" fontSize={14}>
//               <small>Scan a QR code</small>
//             </Typography>
//           )}
//         </Box>
//       </Box>
//       <input id={`dff_${fieldRef}`} type="hidden" name={fieldRef} value={scannedText} />
//     </Box>
//   );
// }

// // Typechecking props of the Transaction
// QRScannerField.propTypes = {
//   fieldRef: PropTypes.string.isRequired,
//   displayName: PropTypes.string.isRequired,
//   options: PropTypes.arrayOf(PropTypes.any),
// };

// QRScannerField.defaultProps = {
//   options: null,
// };

// export default QRScannerField;

import { Html5Qrcode } from "html5-qrcode";

import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Icon,
  Snackbar,
  Alert,
  Box,
  Typography,
  Button,
  IconButton,
  ListItem,
  ListItemText,
} from "@mui/material";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

function QRScannerField({ formRef, draftIndex, displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [isScanning, setIsScanning] = useState(false);
  const [scannedText, setScannedText] = useState(null);
  const [scannerObj, setsCannerObj] = useState(null);

  const config = { fps: 10, qrbox: { width: 250, height: 250 } };

  function onScanSuccess(decodedText, decodedResult) {
    setScannedText(decodedText);
    closeScanning();
  }

  function openScanner(camera) {
    scannerObj.start(camera, config, onScanSuccess);
    setIsScanning(true);
  }

  function closeScanning() {
    if (scannerObj === null) return;

    try {
      scannerObj.stop();
      setIsScanning(false);
    } catch {}
  }

  function initScanning() {
    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          var cameraId = devices[0].id;
          let camera = { deviceId: { exact: cameraId } };
          if (devices.length > 1) {
            camera = { facingMode: "environment" };
          }
          openScanner(camera);
        }
      })
      .catch((err) => {
        setErrorMsg(`Code scan error = ${err}`);
        showFieldError(true);
      });
  }

  useEffect(() => {
    setsCannerObj(new Html5Qrcode(`${fieldRef}_scanner`));
  }, []);

  const [hasSavedValue, setHasSavedValue] = useState(false);
  const [draftValue, setDraftValue] = useState(null);

  useEffect(() => {
    if (!formRef) return;

    const saved = localStorage.getItem(`draft_${formRef}`);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);
      const val = parsed?.[draftIndex].values?.[fieldRef];

      if (val !== undefined && val !== null && val !== "") {
        setDraftValue(val);
        setHasSavedValue(true);
      }
    } catch (e) {
      console.error("Draft parse error", e);
    }
  }, [formRef, fieldRef]);

  return (
    <Box>
      {hasSavedValue ? (
        <MDBox>
          <ListItem divider>
            <MDBox mr={1}>
              <Icon color="success">check_circle</Icon>
            </MDBox>
            <ListItemText
              primary={
                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                  {displayName}
                </MDTypography>
              }
            />
            <MDButton
              size="small"
              color="warning"
              variant="outlined"
              iconOnly
              onClick={() => {
                try {
                  const key = `draft_${formRef}`;
                  const saved = localStorage.getItem(key);
                  if (!saved) return;

                  const parsed = JSON.parse(saved);

                  if (parsed?.values && fieldRef in parsed.values) {
                    delete parsed.values[fieldRef];
                  }

                  // persist updated draft
                  localStorage.setItem(key, JSON.stringify(parsed));

                  // update UI state
                  setHasSavedValue(false);
                  setDraftValue(null);
                } catch (e) {
                  console.error("Failed to clear draft field", e);
                }
              }}
            >
              <Icon>edit</Icon>
            </MDButton>
          </ListItem>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={fieldRef}
            value={draftValue}
          />
        </MDBox>
      ) : (
        <Box>
          {/* ERROR */}
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={5000}
            onClose={() => showFieldError(false)}
            open={fieldError}
          >
            <Alert severity="error" sx={{ width: "100%" }}>
              {errorMsg}
            </Alert>
          </Snackbar>

          <Box sx={{ minWidth: 120, width: "100%" }}>
            {/* HEADER */}
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography
                  variant="h6"
                  fontWeight="light"
                  fontSize="small"
                  mb={2}
                >
                  {displayName}
                </Typography>
              </Grid>

              <Grid mt={-1} item xs={6}>
                <Box align="right">
                  {!isScanning ? (
                    <IconButton onClick={initScanning}>
                      <Icon>qr_code_scanner</Icon>
                    </IconButton>
                  ) : (
                    <IconButton onClick={closeScanning}>
                      <Icon color="error">close</Icon>
                    </IconButton>
                  )}
                </Box>
              </Grid>
            </Grid>

            {/* ✅ CAPTURE BOX (UI ONLY) */}
            <Box
              sx={{
                border: "2px dashed #d2d6da",
                borderRadius: "12px",
                height: 220,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                overflow: "hidden",
                backgroundColor: "#f8f9fa",
                mt: 2,
              }}
            >
              {/* Idle State */}
              {!isScanning && !scannedText && (
                <Box textAlign="center">
                  <IconButton
                    color="primary"
                    onClick={initScanning}
                    sx={{
                      width: 64,
                      height: 64,
                      backgroundColor: "#e3f2fd",
                    }}
                  >
                    <Icon fontSize="large">qr_code_scanner</Icon>
                  </IconButton>

                  <Typography variant="caption" mt={1} display="block">
                    Tap to scan QR code
                  </Typography>
                </Box>
              )}

              {/* Scanner (UNCHANGED, just styled container) */}
              <Box
                id={`${fieldRef}_scanner`}
                sx={{
                  width: isScanning ? "100%" : 0,
                  height: isScanning ? "100%" : 0,
                }}
              />

              {/* Stop button overlay */}
              {isScanning && (
                <IconButton
                  onClick={closeScanning}
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    backgroundColor: "white",
                    border: "1px solid rgba(0,0,0,0.2)",
                    boxShadow: 3,
                  }}
                >
                  <Icon color="error">close</Icon>
                </IconButton>
              )}

              {/* Result State */}
              {!isScanning && scannedText && (
                <Box textAlign="center" px={2}>
                  <Typography variant="caption" display="block" mb={1}>
                    Scan Result
                  </Typography>

                  <Typography variant="caption" sx={{ wordBreak: "break-all" }}>
                    {scannedText}
                  </Typography>

                  <Box mt={1}>
                    <Button size="small" onClick={() => setScannedText(null)}>
                      clear
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>

            {/* ORIGINAL RESULT TEXT (kept intact) */}
            {/* <Box mt={isScanning ? 3 : 0}>
          {!scannedText && (
            <Typography variant="h6" fontSize={14}>
              <small>Scan a QR code</small>
            </Typography>
          )}
        </Box> */}
          </Box>

          <input
            id={`dff_${fieldRef}`}
            type="hidden"
            name={fieldRef}
            value={scannedText}
          />
        </Box>
      )}
    </Box>
  );
}

QRScannerField.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

QRScannerField.defaultProps = {
  options: null,
};

export default QRScannerField;
